module.exports = "/assets/data/0160f020942a2298ab691c7a5a0e7876-SW16.data.json";